import { Box, Flex, Text, Image } from "@chakra-ui/react";
import CodeIcon from "./assets/code.png";
import GoIcon from "@/assets/go.png";

const QrButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <Flex
      onClick={onClick}
      sx={{
        position: "absolute",
        bottom: "0px",
        left: "0%",
        width: "100%",
        height: "100px",
        background: "#D1732C",
      }}
      align={"center"}
      justify={"center"}
    >
      <Text
        sx={{
          color: "#FFF",
          fontSize: "32px",
          fontWeight: 700,
          marginRight: "8px",
        }}
      >
        QR
      </Text>
      <Image
        src={CodeIcon}
        sx={{
          width: "20px",
          marginRight: "8px",
        }}
      ></Image>
      <Image
        src={GoIcon}
        sx={{
          width: "16px",
        }}
      ></Image>
    </Flex>
  );
};

export default QrButton;
